import {isFinanceSelfEmploymentFlow} from './statusConnectionFlow';
import {RegistrationWorkStatus} from './types';

export const MY_TAX_ACCESS_ERROR_TITLE = 'Что-то не так';

export const MY_TAX_ACCESS_ERROR_DESCRIPTION =
	'Кажется, вы не подтвердили запрос прав от Рокет Ворк. Предоставьте доступ в приложении «Мой налог»';

export const ALFA_MY_TAX_ACCESS_ERROR_DESCRIPTION =
	'Кажется, вы не подтвердили запрос прав от Альфа-банк. Предоставьте доступ в приложении «Мой налог»';

export const getMyTaxAccessErrorDescription = (workStatus?: RegistrationWorkStatus | null): string => {
	return isFinanceSelfEmploymentFlow(workStatus ?? null)
		? ALFA_MY_TAX_ACCESS_ERROR_DESCRIPTION
		: MY_TAX_ACCESS_ERROR_DESCRIPTION;
};
